import { render } from "./experiancemodel.vue?vue&type=template&id=591ca595"
import script from "./experiancemodel.vue?vue&type=script&lang=js"
export * from "./experiancemodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__